import { render } from "./ShowImg.vue?vue&type=template&id=71fb9c65"
import script from "./ShowImg.vue?vue&type=script&lang=js"
export * from "./ShowImg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__